import {
  BookOpen, HeartPulse, Stethoscope, Cpu, Car, Network, Cog, Code2,
  Landmark, FlaskConical, Globe2, Award,
  Mail, Phone, MapPin, Clock,
  FileText, ClipboardList, ClipboardCheck, UserPlus, FileCheck2,
  CreditCard, Coins, Bus, UtensilsCrossed, Library, MonitorSmartphone,
  Dumbbell, Briefcase, Wifi, Users,
  Music, Palette, Languages, Trophy, Theater, Brain, Syringe, ShieldPlus,
  Apple, CalendarDays, HeartHandshake,
  Sparkles, Activity,
  Goal, Flag, Footprints, PersonStanding, Sprout, Flower2, Swords, Dribbble, Medal,
} from "lucide-react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_info-oficial/artifacts/m6nqyi0w_escudo%20upp.jfif";
export const CAMPUS_URL =
  "https://customer-assets.emergentagent.com/job_info-oficial/artifacts/u4xntani_upp%202.webp";

export const INSTITUTION = {
  name: "Universidad Politécnica de Pachuca",
  short: "UPP",
  tagline:
    "Educación superior de calidad, integral e incluyente en Zempoala, Hidalgo.",
  founded: "2004",
};

export const HERO = {
  overline: "Organismo Público Descentralizado",
  title: "Toda la información estudiantil de la UPP en un solo lugar",
  subtitle:
    "Una guía digital pensada para ayudarte a encontrar de forma rápida y clara información sobre trámites, becas, servicios universitarios, nuevo ingreso y dudas frecuentes.",
  image:
    "https://customer-assets.emergentagent.com/job_info-oficial/artifacts/cw8cd8c5_ChatGPT%20Image%208%20jul%202026%2C%2009_57_03.png",
};

export const MARQUEE_VALUES = [
  "Excelencia Académica",
  "Innovación",
  "Modelo por Competencias",
  "Investigación",
  "Desarrollo Sustentable",
  "Movilidad Internacional",
  "Ética Profesional",
  "Emprendimiento",
];

export const STATS = [
  { value: "10", label: "Ingenierías y licenciaturas" },
  { value: "21", label: "Programas de posgrado" },
  { value: "1ª", label: "Pública con Médico Cirujano en el subsistema" },
  { value: "Int'l", label: "Movilidad académica y becas" },
];

export const ABOUT = {
  overline: "Nosotros",
  title: "¿Qué podrás encontrar aquí?",
  items: [
    "Información sobre trámites escolares",
    "Orientación sobre becas y apoyos",
    "Datos útiles sobre servicios universitarios",
    "Apoyo para estudiantes de nuevo ingreso",
    "Respuestas a preguntas frecuentes",
  ],
  image:
    "https://customer-assets.emergentagent.com/job_info-oficial/artifacts/da59gnr4_ChatGPT%20Image%2011%20jul%202026%2C%2013_51_21.png",
  card1Title: "¿Por qué usar esta guía?",
  card1Text:
    "Porque te permite consultar información de forma más rápida, organizada y sencilla, sin tener que revisar varias fuentes para entender un mismo tema.",
  card2Title: "¿Cómo está organizada?",
  card2Text:
    "La información de esta plataforma está distribuida por temas clave para facilitar su consulta, de manera que cada estudiante pueda ubicar más rápido lo que necesita.",
};

export const SERVICES = [
  {
    icon: Stethoscope,
    title: "Médico Cirujano",
    desc: "Una carrera para quienes quieren convertir la vocación en acción. Médico Cirujano te prepara para cuidar la salud, tomar decisiones importantes y dedicar tu conocimiento a lo que más importa: la vida.",
  },
  {
    icon: HeartPulse,
    title: "Ingeniería Biomédica",
    desc: "Ingeniería Biomédica es la carrera ideal para quienes quieren unir la tecnología con la salud. Aquí se desarrollan soluciones innovadoras como equipos médicos, sistemas de monitoreo y tecnología de apoyo que pueden mejorar y hasta transformar vidas.",
  },
  {
    icon: FlaskConical,
    title: "Ingeniería en Biotecnología / TSU en Biotecnología",
    desc: "Si te apasiona la ciencia y te emociona descubrir cómo la biología puede cambiar el mundo, Biotecnología es para ti. Esta carrera te impulsa a crear soluciones para la salud, el ambiente y la industria a través de la investigación, la innovación y el conocimiento científico.",
  },
  {
    icon: Landmark,
    title: "Ingeniería Financiera / TSU en Finanzas y Gestión",
    desc: "Ingeniería Financiera combina análisis, estrategia y visión de futuro para tomar decisiones inteligentes en el mundo económico. Es perfecta para quienes quieren entender cómo se mueve el dinero y convertir los números en oportunidades reales.",
  },
  {
    icon: Network,
    title: "Ingeniería Industrial / TSU en Sistemas y Tecnologías Industriales",
    desc: "Ingeniería Industrial forma profesionales capaces de mejorar procesos, optimizar recursos y hacer que las organizaciones funcionen con mayor eficiencia. Es una carrera para quienes quieren liderar, resolver problemas y transformar ideas en resultados.",
  },
  {
    icon: Car,
    title: "Ingeniería Mecánica Automotriz / TSU en Diseño y Manufactura Automotriz",
    desc: "Para quienes sienten pasión por los autos, los motores y la innovación, Ingeniería Mecánica Automotriz es una opción que acelera el futuro. Aquí se aprende a diseñar, mejorar y entender la tecnología que mueve a la industria automotriz.",
  },
  {
    icon: Cog,
    title: "Ingeniería Mecatrónica / TSU en Automatización",
    desc: "Ingeniería Mecatrónica reúne lo mejor de la mecánica, la electrónica, la programación y la automatización. Es la carrera perfecta para quienes sueñan con crear máquinas inteligentes, robots y sistemas que revolucionen la industria.",
  },
  {
    icon: Cpu,
    title: "Ingeniería Mecatrónica Mixto / TSU en Automatización Mixto",
    desc: "Ingeniería Mecatrónica Mixto ofrece una formación moderna y flexible en automatización y tecnologías inteligentes. Es ideal para quienes buscan prepararse en un área de alta demanda con una visión práctica e innovadora.",
  },
  {
    icon: Code2,
    title: "Ingeniería en Tecnologías de la Información e Innovación Digital / TSU en Desarrollo de Software Multiplataforma",
    desc: "Si lo tuyo es crear, programar e innovar en el mundo digital, esta carrera tiene todo para llevarte lejos. Tecnologías de la Información e Innovación Digital te prepara para desarrollar software, soluciones tecnológicas y proyectos que conectan al presente con el futuro.",
  },
  {
    icon: Activity,
    title: "Licenciatura en Terapia Física",
    desc: "Terapia Física es mucho más que rehabilitación: es ayudar a las personas a recuperar movimiento, confianza y calidad de vida. Es una carrera para quienes quieren servir, acompañar y generar un impacto humano muy valioso.",
  },
];

export const NEWS = [
  {
    date: "Convocatoria abierta",
    category: "Admisiones",
    title: "Proceso de nuevo ingreso — Ingenierías, Licenciaturas y Posgrados",
    excerpt:
      "Consulta requisitos, fechas de examen y el proceso de inscripción en el sitio oficial upp.edu.mx.",
  },
  {
    date: "Vida universitaria",
    category: "Investigación",
    title: "Proyectos de investigación e innovación con impacto en el sector salud",
    excerpt:
      "Docentes y estudiantes desarrollan proyectos aplicados a los sectores productivos y de salud del estado.",
  },
  {
    date: "Vinculación",
    category: "Internacional",
    title: "Programas de movilidad académica y becas para estudiantes",
    excerpt:
      "La UPP fortalece su visión global con oportunidades de intercambio nacional e internacional.",
  },
  {
    date: "Comunidad",
    category: "Institucional",
    title: "Acreditaciones y reconocimiento de la calidad educativa",
    excerpt:
      "Los programas de la UPP cuentan con reconocimiento de organismos evaluadores a nivel nacional.",
  },
];

export const CONTACT = {
  overline: "Contacto",
  title: "Estamos para atenderte.",
  details: [
    {
      icon: MapPin,
      label: "Dirección",
      value:
        "Carretera Pachuca – Cd. Sahagún, km 20, Ex-Hacienda de Santa Bárbara, Zempoala, Hidalgo, C.P. 43830",
    },
    { icon: Phone, label: "Teléfono", value: "(771) 547 75 10" },
    { icon: Mail, label: "Correo", value: "upp@upp.edu.mx" },
    { icon: Clock, label: "Horario", value: "Lunes a viernes, 8:00 – 17:00 hrs." },
  ],
};

export const NUEVO_INGRESO = {
  overline: "Guía de Nuevo Ingreso",
  title: "Tu ingreso a la UPP, paso a paso.",
  intro:
    "Este es el proceso general de admisión, común para Médico Cirujano, Terapia Física y las Ingenierías. Consulta las fechas y detalles específicos de tu carrera en la convocatoria correspondiente más abajo.",
  steps: [
    { n: "01", title: "Preregistro en línea", desc: "Completa tus datos (correo, nombre completo y carrera) en el portal de aspirantes y valida tu número de preregistro desde tu correo. Revisa también la carpeta de spam. Fecha límite: 8 de junio de 2026." },
    { n: "02", title: "Pago de la evaluación diagnóstica", desc: "Paga el derecho a la evaluación diagnóstica ($582.00), en línea o de forma presencial en Banorte. Conserva tu comprobante de pago." },
    { n: "03", title: "Pase de ingreso y guía de estudios", desc: "El 11 de junio de 2026, después de las 8:00 p. m., recibirás por correo las indicaciones para obtener tu pase de ingreso y el enlace a la guía de estudios." },
    { n: "04", title: "Prueba psicométrica y entrevista", desc: "Del 29 de junio al 1 de julio de 2026 realiza en línea la prueba psicométrica y el cuestionario o entrevista, usando el correo que registraste." },
    { n: "05", title: "Evaluación diagnóstica", desc: "Presenta la evaluación en la fecha indicada en tu pase de ingreso. Necesitas una computadora funcional que cumpla los requisitos técnicos y acceso a internet." },
    { n: "06", title: "Resultados e inscripción", desc: "Consulta tus resultados (inapelables) por correo o en el portal. Si eres aceptado, realiza tu inscripción en las fechas señaladas (agosto de 2026)." },
  ],
  requirements: [
    "Acta de nacimiento (original y copia)",
    "Certificado de bachillerato o constancia con promedio",
    "CURP actualizada",
    "Comprobante de domicilio",
    "Fotografías tamaño infantil",
    "Comprobante de pago de inscripción",
  ],
};

export const CONVOCATORIAS = {
  overline: "Convocatorias de Admisión",
  title: "Convocatorias por carrera.",
  intro:
    "Consulta el proceso de admisión detallado, paso a paso, para cada programa educativo.",
  items: [
    {
      career: "Médico Cirujano",
      degree: "Licenciatura",
      period: "Septiembre – Diciembre 2026",
      icon: Stethoscope,
      image: "/convocatorias/convocatoria-medico-cirujano-2026.png",
      pdf: "/convocatorias/convocatoria-medico-cirujano-2026.pdf",
      startNote: "Inicio de cuatrimestre: 01 de septiembre de 2026.",
      prerequisitos: [
        "Tener un promedio mínimo de 8.",
        "Contar con un dominio del idioma inglés del 60%.",
      ],
      contactEmail: "admisionmedicocirujano@upp.edu.mx",
      pasos: [
        {
          title: "Registro en línea",
          desc: "Proporciona los datos que se te soliciten: correo electrónico, nombre completo y carrera a la que deseas ingresar. Después de completar el registro, revisa tu correo, valida tu número de preregistro y guarda o imprime la información. Revisa también la carpeta de correo no deseado o spam.",
          link: { url: "https://sii.upp.edu.mx/vista/aspirantes/vPreRegistro.php", label: "Ir al preregistro" },
          note: "Fecha límite para realizar el registro: 8 de junio de 2026.",
        },
        {
          title: "Pago de la evaluación diagnóstica",
          desc: "Una vez registrado, realiza el pago del proceso de evaluación. El costo indicado en la convocatoria es de $582.00. Puedes pagar en línea mediante el Sistema Integral de Información de la Universidad o de manera presencial en cualquier sucursal Banorte. Guarda tu comprobante de pago por si necesitas realizar alguna aclaración.",
          link: { url: "https://serviciosescolares.upp.edu.mx/wp-content/uploads/2022/08/Pago-de-examen-en-linea.pdf", label: "Guía de pago en línea (PDF)" },
        },
        {
          title: "Descarga tu pase de ingreso",
          desc: "El 11 de junio de 2026, después de las 8:00 p. m., recibirás en el correo registrado las indicaciones para obtener tu pase de ingreso a la evaluación diagnóstica. También recibirás el enlace para consultar y descargar la guía de estudios. Si no recibes el correo, comunícate a admisionmedicocirujano@upp.edu.mx.",
          note: "Repórtalo con al menos 48 horas de anticipación a la fecha de la evaluación.",
        },
        {
          title: "Prueba psicométrica y cuestionario / entrevista",
          desc: "Del 29 de junio al 1 de julio de 2026 deberás completar en línea la prueba psicométrica y el cuestionario o entrevista. Para ingresar, utiliza el correo que registraste durante el preregistro. Debes completar todas las actividades del proceso para poder ser considerado.",
        },
        {
          title: "Presentar la evaluación diagnóstica",
          desc: "La evaluación se realizará el 3 de julio de 2026. El horario y las indicaciones específicas aparecerán en tu pase de ingreso. Debes contar con una computadora funcional que cumpla los requisitos técnicos solicitados por la Universidad.",
        },
        {
          title: "Notificación de resultados",
          desc: "La Universidad enviará por correo electrónico a cada aspirante los resultados y los siguientes pasos. El número de aceptados depende de los lugares disponibles. Los resultados son inapelables y el lugar asignado a una persona aceptada no puede transferirse a otra.",
        },
        {
          title: "Inscripción",
          desc: "Formaliza tu inscripción en las fechas indicadas.",
          note: "Fechas de inscripción: 10 y 11 de agosto de 2026.",
        },
      ],
      closing:
        "Guarda todos tus comprobantes, revisa constantemente tu correo y realiza cada actividad dentro de las fechas indicadas. No dejar los trámites para el último día evita problemas durante el proceso. ¡Mucho éxito!",
    },
    {
      career: "Terapia Física e Ingenierías",
      degree: "Licenciatura e Ingenierías",
      period: "Septiembre – Diciembre 2026",
      icon: Cog,
      image: "",
      pdf: "/convocatorias/convocatoria-terapia-ingenierias-2026.pdf",
      prerequisitos: [
        "Tener un promedio mínimo de 7 en el bachillerato.",
      ],
      pasos: [
        {
          title: "Identifica tu carrera",
          desc: "Antes de comenzar el registro, identifica la carrera que quieres estudiar. La convocatoria incluye:",
          list: [
            "Ingeniería Biomédica.",
            "Ingeniería en Biotecnología / TSU en Biotecnología.",
            "Ingeniería Financiera / TSU en Finanzas y Gestión.",
            "Ingeniería Industrial / TSU en Sistemas y Tecnologías Industriales.",
            "Ingeniería Mecánica Automotriz / TSU en Diseño y Manufactura Automotriz.",
            "Ingeniería Mecatrónica / TSU en Automatización.",
            "Ingeniería Mecatrónica Mixto / TSU en Automatización Mixto.",
            "Ingeniería en Tecnologías de la Información e Innovación Digital / TSU en Desarrollo de Software Multiplataforma.",
            "Licenciatura en Terapia Física.",
          ],
        },
        {
          title: "Prerregistro en línea",
          desc: "Realiza tu prerregistro en línea y completa los datos solicitados: correo electrónico, nombre completo y carrera que deseas estudiar. Después revisa el correo que proporcionaste para validar tu número de preregistro. Revisa también la carpeta de spam o correo no deseado.",
          link: { url: "https://sii.upp.edu.mx/vista/aspirantes/vPreRegistro.php", label: "Ir al preregistro" },
          note: "Fecha límite para realizar el registro: 8 de junio de 2026.",
        },
        {
          title: "Pago de la evaluación diagnóstica",
          desc: "Después de tu registro, paga el derecho a presentar la evaluación diagnóstica. El costo indicado es de $582.00 y puedes pagar en línea mediante el Sistema Integral de Información de la Universidad o de forma presencial en cualquier sucursal Banorte.",
          links: [
            { url: "https://serviciosescolares.upp.edu.mx/wp-content/uploads/2022/08/Pago-de-examen-en-linea.pdf", label: "Guía de pago en línea (PDF)" },
            { url: "https://serviciosescolares.upp.edu.mx/wp-content/uploads/2022/08/Pago-de-examen-presencial.pdf", label: "Guía de pago presencial (PDF)" },
          ],
          note: "Después de pagar, conserva tu comprobante. El pago puede tardar entre 48 y 72 horas en reflejarse en el sistema de la Universidad.",
        },
        {
          title: "Obtén tu pase de ingreso",
          desc: "El 11 de junio de 2026, después de las 8:00 p. m., recibirás en el correo registrado las indicaciones para obtener tu pase de ingreso a la evaluación diagnóstica. También recibirás información para consultar y descargar la guía de estudios. Si no recibes el correo, comunícate al correo correspondiente a la carrera que elegiste.",
          note: "Repórtalo por lo menos 48 horas antes de la evaluación.",
        },
        {
          title: "Prueba psicométrica y cuestionario / entrevista",
          desc: "Del 29 de junio al 1 de julio de 2026 deberás realizar en línea la prueba psicométrica y el cuestionario o entrevista. Para ingresar a las plataformas utiliza el correo que registraste durante el preregistro.",
          links: [
            { url: "https://sii.upp.edu.mx/vista/aspirantes/vPsicometricosLogin.php", label: "Prueba psicométrica" },
            { url: "https://rb.gy/t1bc8p", label: "Cuestionario / entrevista" },
          ],
        },
        {
          title: "Presentar la evaluación diagnóstica",
          desc: "La evaluación diagnóstica se realizará el 10 y 17 de julio de 2026, según las indicaciones que aparezcan en tu pase de ingreso. Debes contar con una computadora funcional que cumpla los requisitos técnicos solicitados y acceso a internet. Verifica antes que tu equipo funcione correctamente.",
        },
        {
          title: "Consultar los resultados",
          desc: "Los resultados se publicarán el 7 de agosto de 2026, después de las 11:00 p. m. Los resultados son inapelables y el lugar asignado a una persona aceptada no puede transferirse a otra.",
          link: { url: "https://www.upp.edu.mx/serviciosescolares/", label: "Consultar resultados" },
        },
        {
          title: "Realiza la inscripción",
          desc: "Si fuiste aceptado, realiza tu inscripción siguiendo las indicaciones que se publiquen en la convocatoria de inscripción. Para tener la posibilidad de ser aceptado, debes completar todas las etapas del proceso dentro de las fechas establecidas.",
          note: "Fechas de inscripción: 10 al 21 de agosto de 2026.",
        },
      ],
      closing:
        "Es recomendable guardar tu número de preregistro, comprobante de pago, correos recibidos y cualquier documento relacionado con el proceso.",
    },
  ],
};

export const TRAMITES = {
  overline: "Trámites Escolares",
  title: "Gestiona tus documentos y trámites.",
  items: [
    { icon: FileText, title: "Constancia de estudios", desc: "Documento que acredita tu inscripción vigente.", constancias: {
      tipos: [
        { t: "Constancia de estudios", d: "Acredita que estás inscrito(a) en la universidad." },
        { t: "Constancia con promedio", d: "Incluye tu promedio general." },
        { t: "Constancia con horario", d: "Muestra las materias que cursas y tus horarios." },
        { t: "Constancia con porcentaje de créditos", d: "Indica el avance de tu carrera." },
        { t: "Constancias especiales", d: "Se elaboran cuando una institución solicita información específica (por ejemplo, para becas, trámites laborales o movilidad académica)." },
      ],
      steps: [
        "Realiza el pago correspondiente. (En Servicios Escolares te especificarán más).",
        "Entrega el comprobante de pago en el Departamento de Servicios Escolares e indica qué tipo de constancia necesitas.",
        "Espera el tiempo de elaboración.",
        "Recoge tu constancia en Servicios Escolares.",
      ],
      delivery: "La constancia normalmente se entrega en un plazo de hasta 72 horas después de validar el pago.",
      cost: "$29.00 MXN (equivalente a 0.25 UMA).",
      requisitos: [
        "Comprobante de pago.",
        "Indicar el tipo de constancia que necesitas.",
        "En algunos casos pueden solicitar una identificación oficial.",
      ],
    } },
    { icon: ClipboardList, title: "Historial Académico", desc: "Reporte oficial de calificaciones por cuatrimestre.", info: {
      title: "Historial Académico",
      blocks: [
        { type: "text", text: "Sigue estos pasos para solicitar tu historial académico en Servicios Escolares:" },
        { type: "steps", title: "¿Cómo lo solicitas?", items: [
          "Pagar directamente en el SIUPP, ya sea en banco presencial o por transferencia.",
          "Colocar los siguientes datos en el voucher: nombre, carrera y programa educativo.",
          "Llevar a Servicios Escolares el voucher con la información solicitada.",
          "En un lapso de 2 a 3 días hábiles recibirás el historial académico.",
        ] },
        { type: "list", title: "Costo", variant: "check", items: [
          "$43.00 MXN (pesos mexicanos).",
        ] },
        { type: "note", text: "Asistir con una identificación oficial." },
      ],
    } },
    { icon: ClipboardCheck, title: "Reinscripción", desc: "Proceso para continuar al siguiente periodo académico.", info: {
      title: "Reinscripción",
      blocks: [
        { type: "tagline", text: "¿Listo para continuar con tu carrera?" },
        { type: "text", text: "Reinscribirte es muy fácil: ingresa a SIIUPP, genera tu ficha de pago y realiza el pago mediante transferencia bancaria o en una sucursal Banorte. Una vez realizado el pago, ¡tu reinscripción se procesa automáticamente!" },
      ],
    } },
    { icon: FileCheck2, title: "Título y cédula profesional", desc: "Trámite de titulación y registro ante la SEP.", info: {
      title: "Titulación y cédula profesional",
      blocks: [
        { type: "list", title: "Documentos para el trámite de titulación", variant: "check", items: [
          "Haber obtenido el 100% de créditos que integran el plan de estudios del programa educativo cursado.",
          "No tener adeudos con la UPP (verificable por sistema en tu cuenta del SIIUPP).",
          "Solicitud de registro de título profesional estatal, firmada a tinta negra y con foto.",
          "Acta de nacimiento (la más reciente que tengas).",
          "Certificado de bachillerato. Si fue emitido por alguna Universidad Autónoma del país, necesita legalizarse ante la instancia correspondiente (temporalidad del trámite: mes y medio).",
          "Constancia de autenticidad del certificado de bachillerato, emitida por tu bachillerato de egreso.",
          "CURP (no mayor a tres días anteriores a tu cita).",
          "Constancia de acreditación de servicio social, emitida en la Dirección de Vinculación y Extensión.",
          "Constancia de terminación de servicio social, emitida en la institución o dependencia donde lo realizaste.",
          "Constancia de presentación de estadía, emitida por tu programa educativo.",
          "Carta de liberación expedida en el Departamento de Servicios Bibliotecarios.",
          "Encuesta de seguimiento de egresados.",
          "Doce fotografías recientes tamaño infantil.",
          "Comprobante de pago (deberás traerlo el día de tu cita).",
        ] },
        { type: "note", text: "Considere que debe entregar todos los documentos como se indica; de lo contrario deberá realizar una nueva cita." },
        { type: "text", text: "Deberás entregar 12 fotografías tamaño infantil, de las cuales 1 es para el registro de título profesional estatal, todas con las siguientes características:" },
        { type: "list", title: "Características de las fotografías", variant: "bullet", items: [
          "De frente, de estudio fotográfico, con retoque, con iluminación, en blanco y negro con fondo blanco, impresas en papel mate con adherente.",
          "Nítidas en su revelado, permitiendo ver con claridad rasgos físicos y vestimenta.",
          "Las 12 fotografías deberán ser de la misma toma.",
        ] },
        { type: "list", title: "Vestimenta — Hombres", variant: "bullet", items: [
          "Saco oscuro, camisa blanca y corbata, cabello corto, sin lentes, sin barba y sin bigote.",
        ] },
        { type: "list", title: "Vestimenta — Mujeres", variant: "bullet", items: [
          "Peinado libre (el cabello no deberá cubrir el rostro), saco oscuro, blusa blanca, sin accesorios ostentosos.",
        ] },
      ],
    } },
    { icon: UserPlus, title: "Equivalencias y revalidación", desc: "Reconocimiento de estudios previos.", equivalencia: {
      intro: "La equivalencia de estudios permite que la UPP revise las materias que cursaste en otra universidad para determinar si pueden ser reconocidas y no tengas que volver a cursarlas.",
      steps: [
        { title: "Haz tu pre-registro", sub: [
          "Ingresa al enlace de pre-registro que proporciona la universidad.",
          "Verifica que tu correo, nombre y carrera sean correctos.",
          "Confirma tu registro desde tu correo y descarga la ficha en Servicios Escolares.",
        ] },
        { title: "Realiza el pago", sub: [
          "El costo del trámite es de $350.00 MXN.",
          "En línea mediante el Sistema Integral de Información de la UPP.",
          "En cualquier sucursal de Banorte.",
        ] },
        { title: "Envía tus documentos", sub: [
          "Escanea todos los documentos solicitados (claros y completos, incluyendo ambos lados cuando sea necesario) y envíalos al correo: equivalencia@upp.edu.mx.",
        ] },
        { title: "Entrega los documentos originales", sub: [
          "Después de revisar tus archivos digitales, la universidad te avisará por correo cuándo debes acudir a Servicios Escolares para entregar los documentos originales.",
        ] },
      ],
      important: [
        "Si falta algún documento, no podrá realizarse el trámite.",
        "La aceptación depende de que haya lugares disponibles en la carrera que elegiste.",
        "No todas las materias serán equivalentes; la universidad revisará el contenido y los créditos de cada una.",
      ],
      requisitos: [
        "Si vienes de otra Universidad Politécnica: las materias equivalentes deben representar al menos el 10% de los créditos del plan de estudios.",
        "Si vienes de otra universidad del sistema educativo nacional: las materias equivalentes deben representar al menos el 20% de los créditos y solo se podrá reconocer como máximo el 40% del plan de estudios.",
      ],
      link: {
        url: "https://serviciosescolares.upp.edu.mx/?page_id=1790",
        note: "Aquí encontrarás todo lo que solicitan las equivalencias.",
      },
    } },
    { icon: FileText, title: "Baja temporal o definitiva", desc: "Solicitud de baja de una o más asignaturas.", bajas: {
      intro: "Si por algún motivo necesitas dejar de estudiar en la UPP, puedes solicitar una baja temporal o una baja definitiva mediante el formato correspondiente.",
      temporal: {
        title: "Baja temporal",
        points: [
          "Es para cuando deseas pausar tus estudios y regresar después.",
          "Puedes solicitarla hasta por un año.",
          "Al terminar ese periodo podrás realizar tu trámite para reincorporarte.",
        ],
      },
      definitiva: {
        title: "Baja definitiva",
        points: [
          "Es para cuando decides dejar la universidad de forma permanente.",
          "Si más adelante deseas estudiar nuevamente, deberás seguir el proceso que la universidad establezca para un nuevo ingreso.",
        ],
      },
      steps: [
        { title: "Llena el formato de baja", desc: "Imprime, llena y junta las firmas del Formato de Solicitud de Baja." },
        { title: "Paga la constancia de no adeudo", desc: "Son $27.00 pesos. Págalo en línea desde tu cuenta de alumno en el Sistema Integral de la UPP (opción Pagos), o directo en el área de Recursos Financieros de la universidad." },
        { title: "Junta sellos de no adeudo", desc: "Recaba firmas y sellos en el Formato de No Adeudo para Baja." },
        { title: "Último sello en caja", desc: "Cuando ya tengas los primeros 5 sellos/firmas del formato de no adeudo, lleva tu comprobante de pago del paso 2 al área de caja de la UPP para que te den el último sello y firma." },
        { title: "Entrega en Servicios Escolares", sub: [
          "Formato de solicitud de baja en original y copia.",
          "Formato de no adeudo para baja en original y copia.",
          "Solo si es baja definitiva: también entregar tu credencial de estudiante.",
        ] },
      ],
      important: [
        "Todo debe ir sin tachaduras ni enmendaduras y con todos los sellos/firmas.",
        "Ojo con el Art. 100: si te das de baja después de los primeros 40 días hábiles del inicio del cuatrimestre, todas las materias que estás cursando se te pondrán como no acreditadas.",
      ],
      motivosTitle: "Abandono de estudios",
      motivos: [
        "Incumplimiento de expectativas.",
        "Bajo rendimiento académico.",
        "Falta de interés por los estudios.",
        "Problemas económicos.",
        "Motivos de salud.",
        "Cambio de residencia.",
        "Cambio de institución educativa.",
        "Motivos laborales.",
        "Motivos personales u otros.",
      ],
      documents: [
        { label: "Formato de Solicitud de Baja", url: "/docs/solicitud-baja.pdf" },
        { label: "Formato de No Adeudo para Baja", url: "/docs/no-adeudo-baja.pdf" },
      ],
    } },
  ],
  note: "Los trámites se solicitan en el Departamento de Servicios Escolares, de lunes a viernes de 8:00 a 17:00 hrs.",
};

export const BECAS = {
  overline: "Becas y Apoyos",
  title: "Apoyos para impulsar tu formación.",
  items: [
    {
      icon: UtensilsCrossed,
      title: "Beca Alimenticia",
      desc: "Brinda apoyo para la alimentación de estudiantes que se encuentran en situación de vulnerabilidad económica.",
      requirements: [
        "Nacionalidad mexicana o acreditar su residencia legal en el país.",
        "Documento de inscripción o reinscripción del estudiante (comprobante de pago, tira de materias debidamente sellada por el Departamento de Servicios Escolares).",
        "Presentar la solicitud de Beca por escrito de acuerdo al formato establecido, con una breve exposición de motivos, avalando su buena conducta y necesidad económica por su docente tutora o docente tutor.",
        "Llenar y presentar el Formato Único de la Persona Solicitante (Anexo 1).",
      ],
      documents: [
        { label: "Estudio Socioeconómico", url: "https://www.upp.edu.mx/zstf/becas/2410/F-PL_BC-11-ESTUDIO-SOCIOECONOMICO.pdf" },
        { label: "Solicitud de Beca", url: "https://www.upp.edu.mx/zstf/becas/2410/F-PL_BC-16-SOLICITUD_DE_BECA.pdf" },
        { label: "Formato Único de la Persona Solicitante (FUPS 2026)", url: "https://www.upp.edu.mx/zstf/becas/2602/FUPS_2026.pdf" },
      ],
    },
    {
      icon: Trophy,
      title: "Beca de Representación Institucional Cultural, Académica y/o Deportiva",
      desc: "Dirigida a estudiantes que representan a la UPP en competencias o eventos académicos, culturales, deportivos o de participación comunitaria en los ámbitos estatal, regional, nacional e internacional.",
      requirements: [
        "Nacionalidad mexicana o acreditar su residencia legal en el país.",
        "El Secretario Académico deberá presentar por escrito ante el Comité de Becas el listado y expedientes completos de las y/o los estudiantes que participarán en eventos estatales, regionales, nacionales e internacionales en los ámbitos académicos, culturales, deportivos o de participación comunitaria, en representación de la Universidad.",
        "El Secretario Académico deberá presentar oficio con lista de estudiantes seleccionados de no tener ningún tipo de adeudo con la Universidad; este requisito se exime para las y los estudiantes de nuevo ingreso.",
        "La asignación de la beca será determinada en función de la disponibilidad presupuestal del proyecto en la Universidad y con estricto cumplimiento de los requisitos fiscales y administrativos aplicables.",
      ],
      documents: [
        { label: "Estudio Socioeconómico", url: "https://www.upp.edu.mx/zstf/becas/2410/F-PL_BC-11-ESTUDIO-SOCIOECONOMICO.pdf" },
        { label: "Solicitud de Beca", url: "https://www.upp.edu.mx/zstf/becas/2410/F-PL_BC-16-SOLICITUD_DE_BECA.pdf" },
        { label: "Formato Único de la Persona Solicitante (FUPS 2026)", url: "https://www.upp.edu.mx/zstf/becas/2602/FUPS_2026.pdf" },
      ],
    },
    {
      icon: HeartHandshake,
      title: "Beca de Equidad Social",
      desc: "Apoya a estudiantes con necesidades económicas para favorecer la igualdad de oportunidades y evitar la deserción escolar.",
      requirements: [
        "Nacionalidad mexicana o acreditar su residencia legal en el país.",
        "Documento de inscripción o reinscripción del estudiante (comprobante de pago, tira de materias debidamente sellada por el Departamento de Servicios Escolares).",
        "Presentar la solicitud de Beca por escrito de acuerdo al formato establecido, con una breve exposición de motivos, avalando su buena conducta y necesidad económica por su docente tutora o docente tutor.",
        "Llenar y presentar el Formato Único de la Persona Solicitante (Anexo 1).",
      ],
      documents: [
        { label: "Estudio Socioeconómico", url: "https://www.upp.edu.mx/zstf/becas/2410/F-PL_BC-11-ESTUDIO-SOCIOECONOMICO.pdf" },
        { label: "Solicitud de Beca", url: "https://www.upp.edu.mx/zstf/becas/2410/F-PL_BC-16-SOLICITUD_DE_BECA.pdf" },
        { label: "Formato Único de la Persona Solicitante (FUPS 2026)", url: "https://www.upp.edu.mx/zstf/becas/2602/FUPS_2026.pdf" },
      ],
    },
    {
      icon: Sparkles,
      title: "Jóvenes Escribiendo el Futuro",
      desc: "Beca federal del Programa de Becas Benito Juárez para estudiantes inscritos en instituciones públicas de educación superior, como la UPP.",
      requirements: [
        "Estar inscrito(a) en una institución pública de educación superior, como la UPP.",
        "No recibir otra beca federal destinada al mismo fin.",
        "Preferentemente pertenecer a un hogar en situación de pobreza o vulnerabilidad.",
        "Realizar tu registro dentro de las fechas de la convocatoria federal.",
      ],
      documents: [
        { label: "Sitio oficial · Becas Benito Juárez", url: "https://www.gob.mx/becasbenitojuarez" },
      ],
    },
    {
      icon: Users,
      title: "Becas de Licenciatura para Jefas de Familia de Nacionalidad Mexicana",
      desc: "Programa dirigido a madres mexicanas, jefas de familia, que cursan una licenciatura en una institución pública de educación superior y se encuentran en situación económica vulnerable.",
      requirements: [
        "Ser mujer mexicana, madre y jefa de familia.",
        "Estar inscrita en una licenciatura en una institución pública de educación superior, como la UPP.",
        "Encontrarse dentro del rango de edad establecido en la convocatoria.",
        "Acreditar situación económica vulnerable y buen desempeño académico.",
      ],
      documents: [
        { label: "Sitio oficial · Gobierno de México", url: "https://www.gob.mx/" },
      ],
    },
    {
      icon: BookOpen,
      title: "Becas para la Transformación",
      desc: "Programa de apoyo económico que impulsa la permanencia y el buen desempeño académico de las y los estudiantes.",
      requirements: [
        "Estar inscrito(a) como estudiante activo en la UPP.",
        "Mantener un buen desempeño académico.",
        "Acreditar situación económica que justifique el apoyo.",
        "Realizar el registro dentro de las fechas de la convocatoria correspondiente.",
      ],
      documents: [
        { label: "Sitio oficial · Gobierno de México", url: "https://www.gob.mx/" },
      ],
    },
  ],
};

export const SERVICIOS_UNIV = {
  overline: "Servicios Universitarios",
  title: "Todo lo que necesitas en el campus.",
  items: [
    { icon: Library, title: "Biblioteca", desc: "Acervo físico y digital, salas de estudio." },
    { icon: FlaskConical, title: "Laboratorios", desc: "Equipamiento de vanguardia para prácticas." },
    { icon: MonitorSmartphone, title: "Centro de cómputo", desc: "Equipos y software especializado." },
    { icon: Stethoscope, title: "Servicio médico", desc: "Atención de primer contacto en el campus." },
    { icon: Dumbbell, title: "Deporte y cultura", desc: "Actividades deportivas, artísticas y culturales." },
    { icon: Briefcase, title: "Bolsa de trabajo", desc: "Vinculación laboral y prácticas profesionales." },
    { icon: Users, title: "Tutorías", desc: "Acompañamiento académico personalizado." },
    { icon: Wifi, title: "Conectividad", desc: "Wi-Fi en todo el campus universitario." },
  ],
};

export const FAQ_ITEMS = [
  { q: "¿Cuándo abre la convocatoria de nuevo ingreso?", a: "Las convocatorias se publican en el portal oficial upp.edu.mx. Te recomendamos revisar el sitio con frecuencia para conocer las fechas de cada periodo." },
  { q: "¿Qué documentos necesito para inscribirme?", a: "Acta de nacimiento, certificado de bachillerato, CURP, comprobante de domicilio, fotografías y comprobante de pago. Consulta la sección Guía de Nuevo Ingreso." },
  { q: "¿Qué prórrogas se ofrecen al momento de la inscripción?", a: "Al momento de la inscripción se pueden otorgar las siguientes prórrogas:", bullets: [
    "INE: en caso de ser menor de edad, 180 días naturales.",
    "IMSS: 20 días naturales.",
    "Certificado de bachillerato: siempre y cuando se compruebe que ya se terminó el bachillerato, que todas las asignaturas están aprobadas, que se dé un plazo de entrega y que se tenga un promedio mínimo de 8 (prórroga por 6 meses).",
  ], note: "No hay prórroga sobre la prórroga; estrictamente se debe cumplir en el plazo acordado.", important: "Si no se entregan los documentos con prórroga, no se podrá inscribir al siguiente cuatrimestre." },
  { q: "¿Se debe llevar a Servicios Escolares el comprobante de pago?", a: "No es necesario llevarlo a Servicios Escolares; solo consérvalo en caso de ser necesario." },
];

export const UBICACIONES = {
  overline: "Ubicaciones",
  title: "Encuentra nuestro campus.",
  address:
    "Carretera Pachuca – Cd. Sahagún km 20, Ex-Hacienda de Santa Bárbara, Zempoala, Hidalgo, C.P. 43830",
  mapEmbed:
    "https://www.google.com/maps?q=Universidad%20Polit%C3%A9cnica%20de%20Pachuca%20Zempoala%20Hidalgo&output=embed",
  facts: [
    { icon: Phone, label: "Teléfono", value: "(771) 547 75 10" },
    { icon: Mail, label: "Correo", value: "upp@upp.edu.mx" },
    { icon: Clock, label: "Horario", value: "Lunes a viernes, 8:00 – 17:00 hrs." },
  ],
};

export const EXTRACURRICULARES = {
  overline: "Extracurriculares",
  title: "La UPP oferta estas actividades.",
  items: [
    { icon: Goal, title: "Fútbol rápido", desc: "Prof. Claudio Godínez Ortiz", details: {
      contact: { prof: "Claudio Godínez Ortiz", email: "claudioog009@upp.edu.mx" },
      schedule: [
        { day: "Lunes y miércoles", times: ["G1 · 10:30 a 11:30", "G2 · 11:30 a 12:30", "G3 · 12:30 a 14:00", "G4 · 14:00 a 15:30", "G5 · 15:30 a 17:00", "G6 · 17:00 a 18:30"] },
        { day: "Jueves", times: ["G1 · 10:30 a 11:30", "G2 · 11:30 a 12:30", "G7 · 12:30 a 14:00", "G7 · 14:00 a 15:30"] },
      ],
    } },
    { icon: Dumbbell, title: "Entrenamiento funcional", desc: "Prof. Claudio Godínez Ortiz", details: {
      contact: { prof: "Claudio Godínez Ortiz", email: "claudioog009@upp.edu.mx" },
      schedule: [ { day: "Jueves", times: ["G8 · 15:30 a 18:30"] } ],
    } },
    { icon: Flag, title: "Fútbol americano y Flag Football", desc: "Prof. Edgar Giovani Vázquez Rodríguez", details: {
      contact: { prof: "Edgar Giovani Vázquez Rodríguez", email: "potrosuppfba@upp.edu.mx" },
      schedule: [
        { day: "Miércoles", location: "ITP", times: ["G1 · 13:00 a 15:00", "G2 · 15:00 a 17:00", "G3 · 17:00 a 19:00"] },
        { day: "Jueves", location: "UPP", times: ["G4 · 13:00 a 15:00", "G5 · 15:00 a 17:00", "G6 · 17:00 a 19:00"] },
        { day: "Viernes", location: "UPP", times: ["G7 · 13:00 a 15:00", "G8 · 15:00 a 17:00", "G9 · 17:00 a 19:00"] },
      ],
    } },
    { icon: Footprints, title: "Atletismo", desc: "Prof. Martín Zustaeta Labastida", details: {
      contact: { prof: "Martín Zustaeta Labastida", email: "zustaeta@upp.edu.mx" },
      schedule: [
        { day: "Lunes", location: "Complejo Revolución", times: ["G1 y G2 · 16:00 a 19:00"] },
        { day: "Martes", location: "UPP", times: ["G3 y G4 · 15:00 a 18:00"] },
        { day: "Miércoles", location: "Complejo Revolución", times: ["G1 y G2 · 16:00 a 19:00"] },
        { day: "Jueves", location: "UPP", times: ["G3 y G4 · 15:00 a 18:00"] },
        { day: "Viernes", location: "Complejo Revolución", times: ["G5 · 16:00 a 19:00"] },
        { day: "Sábado", location: "Complejo Revolución", times: ["G6 · 8:30 a 11:30"] },
      ],
    } },
    { icon: Medal, title: "Charrería", desc: "Prof. Alejandro Sánchez Garduño", details: {
      contact: { prof: "Alejandro Sánchez Garduño", email: "charreria@upp.edu.mx" },
      schedule: [ { day: "Lunes a jueves", times: ["15:30 a 18:00"] } ],
    } },
    { icon: PersonStanding, title: "Yoga", desc: "Prof. Armando Geremías Cruz Quiterio", details: {
      contact: { prof: "Armando Geremías Cruz Quiterio", email: "yogazul@upp.edu.mx" },
      schedule: [
        { day: "Lunes", location: "Aula 88", times: ["G1 · 12:00 a 13:30", "G2 · 13:30 a 15:00", "G3 · 15:00 a 16:30", "G4 · 16:30 a 18:00"] },
        { day: "Martes", location: "Aula 88", times: ["G5 · 13:00 a 14:30", "G6 · 14:30 a 16:00", "G7 · 16:00 a 17:30"] },
        { day: "Miércoles", location: "Aula 88", times: ["G1 · 12:00 a 13:30", "G2 · 13:30 a 15:00", "G3 · 15:00 a 16:30", "G4 · 16:30 a 18:00"] },
        { day: "Jueves", location: "Aula 88", times: ["G5 · 13:00 a 14:30", "G6 · 14:30 a 16:00", "G7 · 16:00 a 17:30"] },
      ],
    } },
    { icon: Music, title: "Baile de salón", desc: "Profa. Adriana Salinas Vargas", details: {
      contact: { prof: "Adriana Salinas Vargas", email: "culturaupp@upp.edu.mx" },
      schedule: [
        { day: "Lunes", location: "La Hacienda", times: ["G1 · 7:00 a 9:00", "G5 · 12:00 a 14:00", "G4 · 14:00 a 15:00"] },
        { day: "Martes", location: "La Hacienda", times: ["G2 · 7:00 a 9:00", "G6 · 12:00 a 14:00"] },
        { day: "Miércoles", location: "La Hacienda", times: ["G3 · 7:00 a 9:00", "G4 · 9:00 a 10:00", "G7 · 12:00 a 14:00"] },
      ],
    } },
    { icon: Activity, title: "Fitness & Dance", desc: "Profa. Adriana Salinas Vargas", details: {
      contact: { prof: "Adriana Salinas Vargas", email: "culturaupp@upp.edu.mx" },
      schedule: [ { day: "Lunes y martes", times: ["G1 · 9:00 a 10:00"] } ],
    } },
    { icon: Sprout, title: "Escuela por la tierra", desc: "Mtra. Gregoria Carmen Godínez Flores", details: {
      contact: { prof: "Gregoria Carmen Godínez Flores", email: "carmengodinez@upp.edu.mx" },
      schedule: [
        { day: "Lunes", times: ["G1 · 13:00 a 15:00"] },
        { day: "Viernes", times: ["G2 · 15:30 a 17:00"] },
      ],
    } },
    { icon: Flower2, title: "Jardinería y horticultura", desc: "Prof. Albino Ahumada", details: {
      contact: { prof: "Albino Ahumada", email: "ahumadam@upp.edu.mx" },
      schedule: [ { day: "Martes y jueves", times: ["G1 · 15:30 a 17:00"] } ],
    } },
    { icon: BookOpen, title: "Taller de lectura", desc: "Profa. Sandra Tovar Serrano", details: {
      contact: { prof: "Sandra Tovar Serrano", email: "culturaupp@upp.edu.mx" },
      schedule: [ { day: "Lunes y viernes", times: ["7:00 a 8:00 a. m."] } ],
    } },
    { icon: Swords, title: "Taekwondo", desc: "Prof. Rodrigo Salomón Gaspar Cortez", details: {
      contact: { prof: "Rodrigo Salomón Gaspar Cortez", email: "taekwondo@upp.edu.mx" },
      schedule: [
        { day: "Lunes", times: ["G1 · 14:30 a 16:00", "G2 · 16:00 a 17:30", "G3 · 17:30 a 19:00", "G7 · 19:00 a 20:00"] },
        { day: "Martes", times: ["G4 · 14:30 a 16:00", "G5 · 16:00 a 17:30", "G6 · 17:30 a 19:00", "G8 · 19:00 a 20:00"] },
        { day: "Miércoles", times: ["G1 · 14:30 a 16:00", "G2 · 16:00 a 17:30", "G3 · 17:00 a 19:30", "G7 · 19:00 a 20:00"] },
        { day: "Jueves", times: ["G4 · 14:30 a 16:00", "G5 · 16:00 a 17:30", "G6 · 17:00 a 19:30", "G8 · 19:00 a 20:00"] },
      ],
    } },
    { icon: Dribbble, title: "Baloncesto", desc: "Prof. Rafael César Beltrán", details: {
      contact: { prof: "Rafael César Beltrán", email: "upp.basket.2022@gmail.com" },
      schedule: [
        { day: "Lunes y martes", times: ["G1 y G2 · 15:00 a 18:00"] },
        { day: "Miércoles", times: ["G3 y G4 · 12:00 a 18:00"] },
      ],
    } },
  ],
};

export const SALUD = {
  overline: "Salud",
  title: "Tu bienestar es lo primero.",
  items: [
    { icon: Stethoscope, title: "Servicio médico", desc: "Atención de primer contacto y urgencias menores en el campus.", details: {
      tagline: "Tu bienestar también es prioridad.",
      intro: "La UPP brinda atención médica preventiva y valoración inicial gratuita.",
      services: [
        "Educación para la salud.",
        "Prevención de enfermedades.",
        "Atención preventiva para toda la comunidad universitaria.",
      ],
      location: "A un lado de la velaria.",
      schedule: "Lunes a viernes | 7:00 a 17:30 h",
    } },
    { icon: Brain, title: "Apoyo psicológico", desc: "Acompañamiento y orientación emocional para estudiantes.", details: {
      intro: "Da atención psicológica de primer nivel, gratuita, confidencial y profesional.",
      servicesTitle: "¿Qué hace?",
      services: [
        "Atención individual para tu bienestar emocional durante la universidad.",
        "Talleres, pláticas y conferencias sobre ansiedad, depresión, manejo de emociones, autoestima, habilidades sociales, etc.",
        "Actividades con perspectiva de género sobre igualdad, prevención de violencia y violencia en el noviazgo.",
        "Si necesitas algo más especializado, te orientan y canalizan a otra institución de salud.",
      ],
      location: "Edificio de Docencia 2, planta baja del lado derecho.",
      requirement: "Ser estudiante activo de la UPP.",
      schedule: "Lunes a viernes de 9:00 a 17:00 hrs.",
      citaTitle: "¿Cómo sacas cita?",
      citaSteps: [
        "Manda un correo a psicologia@upp.edu.mx con tu disponibilidad.",
        "Ve directo al Área de Psicología a llenar el formato.",
        "Dile a tu tutor/a para que te canalice.",
      ],
      citaNote: "Las citas se asignan según disponibilidad.",
    } },
    { icon: Activity, title: "Terapia y rehabilitación", desc: "Clínica Universitaria de Rehabilitación Integral.", details: {
      tagline: "Centro de Rehabilitación de la UPP",
      intro: "La Clínica Universitaria de Rehabilitación Integral brinda atención especializada tanto a la comunidad universitaria como al público en general.",
      location: "Enfrente de Administración y RH.",
      blocks: [
        { type: "list", title: "¿Qué servicios ofrece?", variant: "check", items: [
          "Terapia física y rehabilitación.",
          "Prevención y tratamiento de lesiones musculoesqueléticas.",
          "Atención para recuperar la movilidad y mejorar la calidad de vida.",
        ] },
        { type: "list", title: "¿Por qué es importante?", variant: "check", items: [
          "Atención profesional a costos accesibles.",
          "Equipo especializado para apoyar la recuperación física.",
          "Beneficia tanto a estudiantes como a la comunidad externa.",
        ] },
        { type: "list", title: "Áreas de atención", variant: "bullet", items: [
          "Problemas del sistema musculoesquelético.",
          "Rehabilitación cardiorrespiratoria.",
          "Alteraciones neurológicas.",
          "Seguimiento a pacientes posoperados o con lesiones por traumatismo.",
        ] },
        { type: "list", title: "Lo que NO atienden", variant: "warn", items: [
          "Servicios con fines estéticos.",
          "Urgencias médicas del momento (como torceduras recientes sin valoración previa).",
          "Enfermedades generales como gripe o dolor abdominal.",
        ] },
        { type: "steps", title: "Proceso de atención", items: [
          "Valoración médica (indispensable): no puedes ingresar directamente a rehabilitación; primero agenda una cita con el médico de la clínica. Si cuentas con estudios previos (radiografías, análisis, etc.), llévalos ese día. El médico evalúa tu caso y determina si requieres rehabilitación física.",
          "Asignación de terapeuta y horarios: con la orden del médico, regresa a recepción para que te asignen un terapeuta según disponibilidad. En la primera valoración, el terapeuta determina cuántas sesiones necesitarás y la frecuencia por semana.",
          "Sesiones y alta: el seguimiento es continuo y consecutivo. Al terminar las sesiones, el terapeuta evalúa tu avance; si recuperaste la movilidad o función esperada, te da de alta. Si no hay avance o hay recaída, se programa una nueva revaloración médica.",
        ] },
        { type: "list", title: "Reglas de asistencia y funcionamiento", variant: "bullet", items: [
          "Puntualidad: llega 10 minutos antes de tu cita para la toma de signos vitales.",
          "Tolerancia: máximo 15 minutos, pero ese tiempo se pierde de tu sesión (que requiere entre 40 y 50 minutos efectivos para funcionar bien).",
          "Regla de las 3 faltas: si faltas 3 veces consecutivas sin avisar, se te da de baja automáticamente y deberás iniciar el trámite desde cero.",
          "Avisa con al menos 1 hora o 1 día de anticipación si no puedes asistir.",
        ] },
        { type: "list", title: "Vestimenta y material", variant: "bullet", items: [
          "Traer 2 toallas (una pequeña y una de medio baño).",
          "Ropa cómoda para ejercitarse: playera de tirantes/camiseta si la lesión es en miembros superiores (hombro, codo, muñeca) o short si es en miembros inferiores (rodilla, tobillo).",
        ] },
        { type: "info", label: "Costo", value: "$73 MXN por cada sesión de terapia." },
        { type: "info", label: "Forma de pago", value: "En línea/transferencia por el portal SIUPP (sección \"Pago de externos\"). Se recomienda pagar semana a semana, no todo el tratamiento junto." },
        { type: "list", title: "Opción de sede Pachuca (CEFIN)", variant: "bullet", items: [
          "Si te queda más cerca, puedes tomar tus sesiones de rehabilitación en la sede CEFIN en Pachuca.",
          "La cita médica de valoración inicial siempre se realiza en la clínica principal; una vez autorizado el tratamiento, puedes solicitar el traslado de tu expediente a Pachuca. El costo es el mismo.",
        ] },
        { type: "location", label: "Ubicación de la sede CEFIN (Pachuca)", value: "Frente a Galerías / Unidad Deportiva." },
      ],
    } },
    { icon: Apple, title: "Orientación nutricional", desc: "Asesoría para una alimentación saludable.", details: {
      intro: "El servicio de nutrición funciona bajo dos modalidades principales:",
      blocks: [
        { type: "modalities", items: [
          { title: "Por canalización médica (Salud y Rehabilitación)", desc: "El médico general de la clínica evalúa al paciente y, si nota que el peso o los hábitos alimenticios afectan directamente su padecimiento, lo refiere a Nutrición.", example: "Ejemplos: pacientes con lesiones en articulaciones (como rodillas) donde el sobrepeso genera impacto físico, o pacientes con enfermedades como diabetes sin un régimen alimentario adecuado, lo que retrasaría su recuperación." },
          { title: "Atención general / estética", desc: "También se atienden personas de manera independiente que deseen asesoría nutricional general (por ejemplo, quienes buscan bajar de peso o mejorar sus hábitos)." },
        ] },
        { type: "steps", title: "Procedimiento", items: [
          "Agendar la cita: acércate a la recepción de la clínica para revisar los horarios disponibles del nutriólogo y agendar la fecha.",
          "Pago previo: realiza el pago de la consulta a través de la plataforma SIUPP (sección \"Pago de externos\").",
          "Consulta: el día asignado acude a la revisión con el especialista.",
          "Seguimiento: si el nutriólogo determina que requiere verte nuevamente, la cita de seguimiento se agenda en recepción.",
        ] },
        { type: "info", label: "Costo por consulta", value: "$73 MXN por cada sesión o revisión." },
        { type: "info", label: "Forma de pago", value: "Exclusivamente digital (transferencia o pago en línea por el portal SIUPP). No hay cobros en efectivo en recepción ni caja física." },
        { type: "list", title: "Puntos clave", variant: "bullet", items: [
          "Ubicación única: el servicio de nutrición se imparte únicamente en la clínica principal (a diferencia de las terapias físicas, que pueden trasladarse a la sede CEFIN en Pachuca).",
          "Especialistas a cargo: las consultas son brindadas por docentes de la universidad (nutriólogos profesionales que imparten clases).",
        ] },
      ],
    } },
  ],
};

export const ADICIONALES = {
  overline: "Adicionales",
  title: "Recursos y enlaces útiles.",
  items: [
    { icon: CalendarDays, title: "Calendario escolar", desc: "Fechas clave de inscripciones, exámenes y periodos vacacionales.", details: {
      tagline: "Calendario Académico 2025–2026",
      intro: "Licenciatura — cuatrimestral. Consulta las fechas clave del ciclo escolar. Toca la imagen para verla en grande o descárgala.",
      image: "/calendario/calendario-academico-2025-2026.png",
      blocks: [
        { type: "documents", title: "Descargar", items: [
          { label: "Calendario Académico 2025–2026 (imagen)", url: "/calendario/calendario-academico-2025-2026.png" },
        ] },
      ],
    } },
    { icon: Phone, title: "Directorio", desc: "Contactos de departamentos y áreas administrativas.", details: {
      tagline: "Contacto general de la UPP",
      blocks: [
        { type: "info", label: "Teléfono", value: "(771) 547 7510 al 520" },
        { type: "info", label: "Correo institucional", value: "upp@upp.edu.mx" },
        { type: "contacts", title: "Áreas y departamentos", items: [
          { name: "Servicios Escolares", email: "servescolares@upp.edu.mx", ext: "(771) 547 7510 · Ext. 2213" },
          { name: "Educación Continua y a Distancia", email: "adistancia@upp.edu.mx", ext: "(771) 547 7510 · Ext. 2316" },
          { name: "Rectoría", email: "upp@upp.edu.mx", ext: "Ext. 2200" },
          { name: "Secretaría Académica", email: "secretariaacademica@upp.edu.mx", ext: "Ext. 2205" },
          { name: "Secretaría Administrativa", email: "administracion@upp.edu.mx", ext: "Ext. 2464 y 2213" },
        ] },
      ],
    } },
    { icon: Bus, title: "Transporte", desc: "Rutas y opciones de traslado hacia el campus." },
  ],
};

export const EQUINOTERAPIA = {
  headline1: "¡ACTIVIDADES",
  headline2: "PARA TODO PÚBLICO!",
  name: "Centro Ecuestre y de Equinoterapia",
  acronym: "(CEETUPP)",
  description:
    "CEETUPP te ofrece terapias asistidas con caballos y equinoterapia con atención especializada.",
  courses: "Cursos de capacitación en junio y octubre.",
  trained: "Más de 200 personas capacitadas.",
  scheduleLabel: "Horario",
  scheduleDays: "Lunes a viernes",
  scheduleHours: "9:00 a 14:00 h",
  priceLabel: "SOLO",
  price: "$32",
  priceNote: "por sesión",
};

export const FLYERS = [
  {
    src: "/flyers/equinoterapia.png",
    title: "Equinoterapia (CEETUPP)",
    caption: "Actividades para todo público",
  },
  {
    src: "/flyers/charreria.png",
    title: "Clases de Charrería",
    caption: "Público en general",
  },
];

export const ESTADIAS = {
  overline: "Estadías / Servicio Social",
  title: "Vincula tu formación con el mundo profesional.",
  items: [
    { icon: HeartHandshake, title: "Servicio social", desc: "Actividad de apoyo a la comunidad que realizas como parte de tu formación, conforme al porcentaje de créditos y horas establecidas por la Universidad.", details: {
      tagline: "¡El servicio social te acerca a tu título!",
      intro: "Es obligatorio para titularte. Realízalo aplicando lo aprendido en beneficio de la sociedad. Este es el proceso completo, del inicio al término.",
      blocks: [
        { type: "steps", title: "Proceso al inicio", items: [
          "Contar con el 55% de las asignaturas cursadas (lo puedes consultar en tu SIIUPP).",
          "Asistir a la plática informativa, de carácter obligatorio. El aviso se publica en la vitrina de la Dirección de Vinculación y en la página de Facebook «Servicio Social UPP».",
          "Reunir los documentos solicitados (ver lista abajo).",
          "Entregar los documentos en el área de Servicio Social, en la fecha estipulada y dentro del horario marcado.",
        ] },
        { type: "list", title: "Documentos a reunir", variant: "check", items: [
          "Solicitud de Asignación de Servicio Social debidamente llenada (se obtiene en el SIIUPP, sesión de alumnos).",
          "Constancia de estudios del cuatrimestre mayo–agosto 2026, emitida por Servicios Escolares (realiza el pago bajo el concepto CONSTANCIA DE ESTUDIOS, con un costo de $29 pesos).",
          "Constancia indicando el número de seguridad social, emitida por Servicios Escolares (realiza el pago bajo el concepto CONSTANCIA DE ESTUDIOS, con un costo de $29 pesos).",
        ] },
        { type: "text", text: "Requisitos: todos los requisitos deberán entregarse en un folder beige, sin manchaduras ni enmendaduras, con etiqueta en la pestaña del mismo, impresa con nombre completo (iniciando por apellidos), letra Arial No. 14, de 1 cm de alto y al ancho del nombre, en mayúsculas y con los requisitos en orden." },
        { type: "info", label: "Horario de entrega", value: "Oficina de Servicio Social, de 10:00 a. m. a 1:30 p. m. Solo se tomarán en cuenta documentos correctos y completos." },
        { type: "list", title: "Después de entregar tus documentos", items: [
          "3 días hábiles después se te otorgará una carta de presentación.",
          "5 días hábiles posteriores deberás entregar en el área de Servicio Social tu carta de aceptación emitida por la institución receptora.",
        ] },
        { type: "steps", title: "Proceso durante", items: [
          "Reporte bimestral: cada dos meses a partir del inicio de tu servicio social, llena en tu SIIUPP el formato de reporte, imprímelo y solicita las firmas correspondientes.",
          "Duración: tu servicio social deberá durar mínimo seis meses y cumplir con 480 horas de servicio.",
        ] },
        { type: "list", title: "Importante", variant: "warn", items: [
          "Es un incumplimiento no generar tus reportes bimestrales.",
        ] },
        { type: "steps", title: "Proceso al término", items: [
          "Reúne tus documentos de término (ver lista abajo).",
          "Entrega los documentos en la fecha estipulada (se publica en redes sociales) en el área de Servicio Social.",
          "Constancia de acreditación: se te otorga en promedio un mes después de entregar tus documentos de término. Acredita que culminaste tu proceso y se requiere para la titulación.",
        ] },
        { type: "list", title: "Documentos de término", variant: "check", items: [
          "Carta de terminación (original y copia).",
          "Todos tus reportes bimestrales firmados y sellados.",
          "Reporte final firmado y sellado.",
          "Hoja de validación de reportes.",
          "Encuesta de satisfacción de la institución prestataria.",
          "Encuesta de satisfacción del alumno.",
          "2 fotografías óvalo en blanco y negro de 3.5 x 5 cm.",
          "Fotografía digital (JPG) tipo infantil, en blanco y negro.",
          "CURP en formato PDF.",
        ] },
        { type: "documents", title: "Enlaces útiles", items: [
          { label: "Video del proceso de servicio social", url: "https://drive.google.com/file/d/12JG-FVg-deWRGHP55x7Ep8F8cIjJp3lC/view?usp=sharing" },
          { label: "Programas de servicio interno", url: "https://docs.google.com/spreadsheets/d/1ncCO8pjs5jyB-yF6fhI0-HkZaYMpGaP9/edit?usp=sharing&ouid=100191491787258856475&rtpof=true&sd=true" },
          { label: "Programas de servicio externo", url: "https://docs.google.com/spreadsheets/d/14aYPfrkfssAYrDLSZEQTED6C2frWXW2k/edit?usp=sharing&ouid=100191491787258856475&rtpof=true&sd=true" },
        ] },
        { type: "info", label: "Síguelos en Facebook", value: "Servicio Social UPP" },
      ],
    } },
    { icon: Briefcase, title: "Estadía profesional", desc: "Estancia en una empresa u organización para aplicar tus conocimientos en un proyecto real; es requisito para egresar.", notice: "Estamos en espera de nueva información debido a la actualización de la convocatoria." },
  ],
};

export const NAV_LINKS = [
  { label: "Inicio", href: "#inicio" },
  { label: "Guía de nuevo ingreso", href: "#nuevo-ingreso" },
  { label: "Trámites escolares", href: "#tramites" },
  { label: "Becas y apoyos", href: "#becas" },
  { label: "Estadías / Servicio social", href: "#estadias" },
  { label: "Extracurriculares", href: "#extracurriculares" },
  { label: "Salud", href: "#salud" },
  { label: "Adicionales", href: "#adicionales" },
  { label: "Preguntas frecuentes", href: "#faq" },
  { label: "Ubicaciones", href: "#ubicaciones" },
  { label: "Contacto", href: "#contacto" },
];

export { Network, Cog, Code2, Award, BookOpen };
